import { render, staticRenderFns } from "./EditQuestionHeader.vue?vue&type=template&id=31b97920&scoped=true"
import script from "./EditQuestionHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./EditQuestionHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditQuestionHeader.vue?vue&type=style&index=0&id=31b97920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b97920",
  null
  
)

export default component.exports